<template>
  <div class="page" v-if="!mobile">
    <component :is="layout + '-layout'" v-if="layout" />
  </div>
  <div v-else class="mobile-message">
    <h2 class="title">Sorry, this app is not supported on Mobile Devices</h2>
    <p class="text">To use this app, please use a computer</p>
  </div>
</template>

<script>
import MainLayout from '@/layout/MainLayout';
import SecondLayout from '@/layout/SecondLayout';
import WithoutHeaderLayout from '@/layout/WithoutHeaderLayout';
import { useRoute } from 'vue-router'
import { computed, ref } from "vue";

export default {
  setup() {
    const mobile = ref(null)
    const route = useRoute()

    const checkScreen = () => {
      const windowWidth = window.innerWidth;

      if (windowWidth <= 1300) {
        mobile.value = true;
        return;
      }
      mobile.value = false;
    }

    window.addEventListener("resize", checkScreen);
    checkScreen()

    return {
      layout: computed(() => route.meta.layout),
      mobile
    }
  },
  components: {
    MainLayout,
    SecondLayout,
    WithoutHeaderLayout,
  }
}
</script>

<style lang="scss">
.page {
  min-height: 100vh;
  overflow: hidden;
}

.mobile-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  padding: 0 5px;

  .title {
    margin-bottom: 20px;

    font-weight: 500;
    font-size: 4.8rem;
  }

  .text {
    font-size: 3.2rem;
  }
}
</style>